// src/util/browser-shouldRetry.js
var browser_shouldRetry_default = function browser_shouldRetry_default(err, attempt, options) {
  if (options.method !== "GET" && options.method !== "HEAD") {
    return false;
  }

  return err.isNetworkError || false;
}; // src/middleware/retry.js


var isStream = function isStream(stream) {
  return stream !== null && typeof stream === "object" && typeof stream.pipe === "function";
};

var retry = function retry() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var maxRetries = opts.maxRetries || 5;
  var retryDelay = opts.retryDelay || getRetryDelay;
  var allowRetry = opts.shouldRetry || browser_shouldRetry_default;
  return {
    onError: function onError(err, context) {
      var options = context.options;
      var max = options.maxRetries || maxRetries;
      var shouldRetry = options.shouldRetry || allowRetry;
      var attemptNumber = options.attemptNumber || 0;

      if (isStream(options.body)) {
        return err;
      }

      if (!shouldRetry(err, attemptNumber, options) || attemptNumber >= max) {
        return err;
      }

      var newContext = Object.assign({}, context, {
        options: Object.assign({}, options, {
          attemptNumber: attemptNumber + 1
        })
      });
      setTimeout(function () {
        return context.channels.request.publish(newContext);
      }, retryDelay(attemptNumber));
      return null;
    }
  };
};

retry.shouldRetry = browser_shouldRetry_default;
var retry_default = retry;

function getRetryDelay(attemptNum) {
  return 100 * Math.pow(2, attemptNum) + Math.random() * 100;
}

export { retry_default };